<template>

<v-dialog v-model="dialog" width="35%">
  <v-card>
    <p class=".title ml-4 pt-4" style="font-weight: bold !important;">Rebook booking {{huov.huov_code}}</p>
    <v-form ref="huovRebook" v-model="huovRebookValid">
     <v-container>
       <div class="ml-1 mb-4">When 'rebook' put a 'close' restriction on the planning ?<br /></div>
       <!-- <v-row>    
       <v-col cols="4">
          <v-select v-model="huov.huov_dag" :items="dagKeuzes" menu-props="auto" item-value="dag_nr" item-text="dag_oms" label="Close"></v-select>
       </v-col>     
       <v-col cols="4">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_van_dat" 
              label="From date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="huov.huov_van_dat2" :first-day-of-week="1" @input="huov.huov_van_dat = $moment(huov.huov_van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

          <v-col cols="4">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_tm_dat" 
              label="Until date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="huov.huov_tm_dat2" :first-day-of-week="1" @input="huov.huov_tm_dat = $moment(huov.huov_tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>
        </v-row> -->
        <div style="display: flex; flex-direction: row; align-items: center; gap: 35px; margin-left: 5px !important;">
          <div style="width: 15%">
            <v-select 
              dense 
              v-model="huov.huov_dag" 
              :items="dagKeuzes" 
              menu-props="auto" 
              item-value="dag_nr" 
              item-text="dag_oms" 
              label="Close">
            </v-select>
          </div>
            <div style="width: 30%">
            <date_picker label="From date"                                 
                          :date="bookingDateFrom2"
                          field="bookingDateFrom2" 
                          icon="mdi-calendar-month-outline"
                          :isClearable="false" 
                          @updateData="updateData"
                          /> 
                        </div>
                        <div style="width: 30%">
            <date_picker label="Until date"                                 
                          :date="bookingDateUntil2"
                          field="bookingDateUntil2" 
                          icon="mdi-calendar-month-outline"
                          :isClearable="false" 
                          @updateData="updateData"
                          /> 
                        </div>              
        </div>                  
      </v-container>  

      <div class="ml-4 pr-2" style="width: calc(45% + 35px) !important">
        <v-select dense v-model="initiated" :items="huov.initiatedKeuzes" item-value="id"  item-text="desc" label="Initiated" :rules="initiatedRules" @change="handleInitiatedChange"></v-select>
      </div>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="huovRebook" :disabled="!huovRebookValid">Rebook the booking</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

import date_picker from '@/components/ui/date_picker.vue';

export default {
  data() {
    return {
    dialog: false,
    huovRebookValid: false,
    huov_encrid: null,
    huov_bedrag: null,
    initiatedKeuzes: [],
    initiated: null,
    huov: {},
    dagKeuzes: [],
    dat1menu: false,
    dat2menu: false,
    bookingDateFrom2: null,
    bookingDateUntil2: null,    
    initiatedRules: [
          v => (v && v.length >= 3) || "Who has initiated the Rebooking"
      ],
    }  
  },
  components: {
        date_picker,
    },  
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/getHuovToRebook.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovToRebook"
          },
          getHuovToRebook: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovToRebook;
            this.initiatedKeuzes = res.data.getHuovToRebook.initiatedKeuzes
            this.dagKeuzes = res.data.getHuovToRebook.huov_dagKeuzes
            this.bookingDateFrom2 = res.data.getHuovToRebook.huov_van_dat2
            this.bookingDateUntil2 = res.data.getHuovToRebook.huov_tm_dat2
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateData(data){
        console.log('updateData', data);
        this[data.field] = data.value;
    },
    handleInitiatedChange(value) {
      this.huov.huov_dag = String(value) === 'Guest2,0' ? 0 : 1;
    },
    huovRebook() { 
      this.$axios
        .post("ares/json/ares/huov/huovRebookv2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "huovRebook"
          },
          huovRebook: {
            huov_encrid: this.huov_encrid,
            initiated: this.initiated,
            huov_dag: parseInt(this.huov.huov_dag),
            huov_van_dat: this.bookingDateFrom2,
            huov_tm_dat: this.bookingDateUntil2,  
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.huovRebook.huov_encrid);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.huovRebook.text,
              color: res.data.huovRebook.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

